/** Matches catalog Availability */
export enum Availability {
  OutOfStock = "OUT_OF_STOCK",
  LowStock = "LOW_STOCK",
  InStock = "IN_STOCK",
  Disabled = "DISABLED",
  Discontinued = "DISCONTINUED",
}
